if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

    get selectedOptionValues() {
  const selected = Array.from(
    this.querySelectorAll(
      'select option[selected], fieldset input:checked'
    )
  ).filter((input) => input.dataset.optionValueId);

  selected.sort((a, b) => {
    const positionA = Number(
      a.closest('[data-option-position]')?.dataset.optionPosition || 0
    );
    const positionB = Number(
      b.closest('[data-option-position]')?.dataset.optionPosition || 0
    );

    return positionA - positionB;
  });

  return selected.map((input) => input.dataset.optionValueId);
}


      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
  this.syncPhotos(false);

  this.addEventListener('click', (event) => {
    const upgrade = event.target.closest('.mtb-photos-upgrade');
    if (!upgrade) return;

    event.preventDefault();

    const formula = this.querySelector('.mtb-formula-picker');
    if (!formula) return;

    const integral = Array.from(
      formula.querySelectorAll('input[type="radio"]')
    ).find((input) => this.normalizePhotoText(input.value).startsWith('integrale'));

    if (integral) {
      integral.checked = true;
      integral.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

 this.addEventListener('change', (event) => {
 const changedOption = event.target.tagName === 'SELECT'
  ? event.target.selectedOptions[0]
  : event.target;

if (!changedOption || !changedOption.dataset.optionValueId) {
  return;
}


  this.updateSelectedSwatchValue(event);


    // Corriger la quantité avant de transmettre les choix au thème.
    this.syncPhotos(true);

    const target = this.getInputForEventTarget(event.target);

    FoxTheme.pubsub.publish(
      FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
      {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      }
    );
  });
}

normalizePhotoText(value) {
  return String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

syncPhotos(correctSelection) {
  const formula = this.querySelector('.mtb-formula-picker');
  const photos = this.querySelector('.mtb-photos-picker');

  if (!formula || !photos) return;

  const selectedFormula = formula.querySelector('input[type="radio"]:checked');
  const integral = selectedFormula &&
    this.normalizePhotoText(selectedFormula.value).startsWith('integrale');

  photos.classList.toggle('is-integral', Boolean(integral));

  if (!correctSelection) return;

  const inputs = Array.from(photos.querySelectorAll('input[type="radio"]'));
  const selected = inputs.find((input) => input.checked);
  const withoutPhotos = inputs.find((input) =>
    this.normalizePhotoText(input.value).startsWith('sans')
  );
  const tenPhotos = inputs.find((input) =>
    /^10\s+photos/.test(this.normalizePhotoText(input.value))
  );

  let next = null;

  if (integral) {
    if (!selected || this.normalizePhotoText(selected.value).startsWith('sans')) {
      next = tenPhotos;
    }
  } else {
    next = withoutPhotos;
  }

  if (next && !next.checked) {
    next.checked = true;
    this.updateSelectedSwatchValue({ target: next });
  }
}


      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
